import { useQuery } from 'react-query';
import axios from 'axios';
import { backendLink } from '../constants';
import { privateAxios } from '../utils';

export const useProduct = (params) => {
    const fetchProduct = () =>
        axios
            .get(
                `${backendLink}ads`,
                { params }
                // {
                // 	headers: {
                // 		...headers,
                // 		'Content-Type': 'application/json',
                // 		'ngrok-skip-browser-warning': 'skip-browser-warning',
                // 	},
                // }
            )
            .then((res) => res?.data);

    return useQuery(['all-product', params], fetchProduct, {
        refetchOnWindowFocus: false,
        refetchInterval: 180000,
        keepPreviousData: false,
        cacheTime: Infinity,
        staleTime: Infinity,
    });
};

export const fetchProduct = (ad_id, option = {}) => {
    const { isLogin = false, query } = option;
    if (query) {
        const queryString = new URLSearchParams(query).toString();
        ad_id = `${ad_id}?${queryString}`;
    }
    const fetchSingleProduct = isLogin
        ? () => privateAxios.get(`${backendLink}ads/${ad_id}`)
        : () => axios.get(`${backendLink}ads/${ad_id}`);

    // eslint-disable-next-line react-hooks/rules-of-hooks
    return useQuery(['fetch-product', ad_id], fetchSingleProduct, {
        refetchInterval: 180000,
        refetchIntervalInBackground: false,
        refetchOnWindowFocus: false,
    });
};

export const fetchCategorySummary = (cat_id) => {
    const fetchCatSummary = () =>
        axios.get(`${backendLink}ads/cat_summary/${cat_id}`).then((res) => res?.data);

    // eslint-disable-next-line react-hooks/rules-of-hooks
    return useQuery(['fetchCatSummary', cat_id], fetchCatSummary, {
        refetchInterval: 180000,
        refetchIntervalInBackground: false,
        refetchOnWindowFocus: false,
        cacheTime: Infinity,
        staleTime: Infinity,
    });
};
